//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

(function() {
  const curalate = angular.module('curalate');

  curalate.service('ContentLibrarySearchFilterHelper', [
    'CONTENT_LIBRARY_CONTENT_GROUPS',
    'SEARCH_FILTERS',
    function(
            CONTENT_LIBRARY_CONTENT_GROUPS,
            SEARCH_FILTERS,
        ) {
      const self = this;

      self.userFilterInitialStateFromSetting = function(userIdsSelectionSetting) {
        let initialUserIdsOptions = [];
        let initialContentGroupOptions = [];

        if (userIdsSelectionSetting === undefined) {
          initialContentGroupOptions = [CONTENT_LIBRARY_CONTENT_GROUPS.TEAM]; // default to Team selection
        } else if (_(userIdsSelectionSetting).isEmpty()) {
          initialContentGroupOptions = [CONTENT_LIBRARY_CONTENT_GROUPS.ALL];
        } else if (userIdsSelectionSetting.length === 1 && (userIdsSelectionSetting[0] === 'team')) { // backwards compatibility case
          initialContentGroupOptions = [CONTENT_LIBRARY_CONTENT_GROUPS.TEAM];
        } else if (userIdsSelectionSetting.length === 1 && (userIdsSelectionSetting[0] === 'Team' || userIdsSelectionSetting[0] === 'All')) {
          initialContentGroupOptions = userIdsSelectionSetting;
        } else {
          initialUserIdsOptions = userIdsSelectionSetting;
        }

        return {
          userIdState: initialUserIdsOptions,
          contentGroupState: initialContentGroupOptions,
        };
      };

      self.userDropdownOptionsFromFilters = function(filterSetModel) {
        const userIdsOption = _(filterSetModel).safeGet('userIds.0');
        const contentGroupOption = _(filterSetModel).safeGet('contentGroup.0');
        const dropdownNameOptionsObject = { setName: SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS };
        if (userIdsOption) {
          dropdownNameOptionsObject.key = 'userIds';
          dropdownNameOptionsObject.option = userIdsOption;
        } else if (contentGroupOption) {
          dropdownNameOptionsObject.key = 'contentGroup';
          dropdownNameOptionsObject.option = contentGroupOption;
        }
        return dropdownNameOptionsObject;
      };

      self.newUserIdsSelectionSettingFromFilters = function(filterSetModel) {
        const userIdsOption = _(filterSetModel).safeGet('userIds.0');
        const contentGroupOption = _(filterSetModel).safeGet('contentGroup.0');
        let newUserIdsSelection = [];
        if (userIdsOption) {
          newUserIdsSelection = [userIdsOption];
        }
        if (contentGroupOption) {
                    // TODO migrate to writing All to settings, 1. allow reading All and null, 2. write All
          if (contentGroupOption !== 'All') {
            if (contentGroupOption === 'Team') {
                            // backwards compatibility to previous value
              newUserIdsSelection = ['team'];
            } else {
              newUserIdsSelection = [contentGroupOption];
            }
          }
        }

        return newUserIdsSelection;
      };
    },
  ]);
})();
